import { render } from "./skraceneNovosti.vue?vue&type=template&id=57b92f9d"
import script from "./skraceneNovosti.vue?vue&type=script&lang=js"
export * from "./skraceneNovosti.vue?vue&type=script&lang=js"

import "./skraceneNovosti.vue?vue&type=style&index=0&id=57b92f9d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__